export const API_VERSION = process.env.REACT_APP_SITE_VERSION;
export const API_VERSION_REFRESH_INTERVAL = 600000;